let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kUxEd")).then(() => parcelRequire('7Mhsu'));